import { Plus } from 'lucide-react';

export function MobilePageHeader({ eyebrow, title, actionLabel, onAction }: { eyebrow?: string; title: string; actionLabel?: string; onAction?: () => void }) {
  return (
    <section className="mobile-page-header">
      <div>
        {eyebrow ? <span>{eyebrow}</span> : null}
        <h1>{title}</h1>
      </div>
      {actionLabel ? (
        <button type="button" className="theme-btn-primary" onClick={onAction}>
          <Plus size={17} aria-hidden="true" />
          {actionLabel}
        </button>
      ) : null}
    </section>
  );
}
